module.exports = __webpack_public_path__ + "ed3ddcd145fedacc3cefaaf27e470271.pdf";